import { ArrowRight } from "lucide-react";
import { useLang, tx } from "@/context/LanguageContext";
import { ROUTES_PRICING } from "@/data";

export const Pricing = () => {
  const { t, lang } = useLang();
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="pricing" className="py-20 md:py-32 bg-sand" data-testid="pricing-section">
      <div className="px-6 md:px-12 lg:px-20 mx-auto max-w-6xl">
        <div className="max-w-2xl mb-14">
          <p className="font-body text-xs tracking-[0.25em] uppercase text-teal font-bold mb-4">{t.pricing.overline}</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-jungle mb-5">{t.pricing.title}</h2>
          <p className="font-body text-jungle-light/80 leading-relaxed">{t.pricing.subtitle}</p>
        </div>

        <div className="border border-border bg-white overflow-hidden">
          <div className="hidden md:grid grid-cols-12 bg-jungle text-sand font-body text-xs uppercase tracking-wider px-6 py-4">
            <div className="col-span-6">{t.pricing.colRoute}</div>
            <div className="col-span-3">{t.pricing.colVehicle}</div>
            <div className="col-span-3 text-right">{t.pricing.colPrice}</div>
          </div>
          {ROUTES_PRICING.map((r, i) => (
            <div
              key={i}
              data-testid={`pricing-row-${i}`}
              className="grid grid-cols-2 md:grid-cols-12 gap-2 px-6 py-5 border-t border-border items-center hover:bg-sand-surface transition-colors"
            >
              <div className="col-span-2 md:col-span-6 font-body text-sm text-jungle font-medium">{tx(r.route, lang)}</div>
              <div className="md:col-span-3 font-body text-sm text-jungle-light/70">{tx(r.vehicle, lang)}</div>
              <div className="md:col-span-3 text-right font-heading text-2xl font-semibold text-teal">
                ${r.price}<span className="text-xs font-body text-jungle-light/60 ml-1">USD</span>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center justify-between mt-6 gap-4">
          <p className="font-body text-xs text-jungle-light/60">{t.pricing.note}</p>
          <button
            onClick={() => go("#book")}
            data-testid="pricing-quote-button"
            className="group inline-flex items-center gap-2 bg-teal text-sand hover:bg-teal-dark font-body px-8 py-4 transition-colors self-start"
          >
            {t.pricing.cta}
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
};
